import { cssThemedValue } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import MonetaryAmount from 'common/formatting/MonetaryAmount';
import { Typography } from 'common/typography';
import { useCampaignModuleContext } from 'modules/campaigns/context';

export type AdsCampaignWeeklyBudgetDetailsProps = {
  budgetAmount: number;
  bidAmount?: number;
};

const CustomValuesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-block-start: 12px;
  padding-block-end: 8px;
`;

const CustomValueRow = styled.div`
  display: flex;
  gap: 16px;
`;

const CustomValueHeader = styled(Typography.Body3)`
  color: ${cssThemedValue('textSecondary')};
  min-width: 64px;
`;

export const AdsCampaignWeeklyBudgetDetails = ({ budgetAmount, bidAmount }: AdsCampaignWeeklyBudgetDetailsProps) => {
  const { currency } = useCampaignModuleContext();

  return (
    <CustomValuesWrapper>
      <CustomValueRow>
        <CustomValueHeader fontWeight="semiBold">
          <FormattedMessage id="campaigns.ads.budget.weekly-budget" />
        </CustomValueHeader>
        <Typography.Body3>
          <MonetaryAmount amount={Number(budgetAmount)} currency={currency} />
        </Typography.Body3>
      </CustomValueRow>
      {bidAmount !== undefined && (
        <CustomValueRow>
          <CustomValueHeader fontWeight="semiBold">
            <FormattedMessage id="campaigns.ads.bid.bid-amount" />
          </CustomValueHeader>
          <Typography.Body3>
            <MonetaryAmount amount={Number(bidAmount)} currency={currency} />
          </Typography.Body3>
        </CustomValueRow>
      )}
    </CustomValuesWrapper>
  );
};
